<template>
    <div id="invoice-ticket-component">
        <div class="row">
            <form id="ticket_form" class="ticket_form">

                <div v-for="(row, index) in invoice_array" :key="index">
                    <input type="hidden" name="invoice_array[]" :value="row">
                </div>
                <input type="hidden" name="type_model" id="" :value="type_model">
                <input type="hidden" name="supplier_id" id="" :value="supplier_id">
                <input type="hidden" name="note_refund" id="" :value="note_refund">
                <div class="col-12 col-sm-12">
                    <input type="text" name="monto" class="al-inputs required scr-input" placeholder="Monto" id="monto">
                </div>
                <div class="col-12 col-sm-12">
                    <div class="fotoUploader">
                    <span class="btn btn-file">
                        Documento <br> <i class="fas fa-upload"></i>
                        <input type="file"
                               class="required"
                               accept="image/*,.pdf"
                               data-name-input="ticketImg"
                               name="ticketImg"
                               v-on:change="getLogo"
                               placeholder="ticketImg">
                    </span>
                        <span class="label-file-papeleria alert alert-info ticket"></span>
                    </div>
                </div>
                <div class="col-12 col-sm-12">
                    <p class="fotoUploader">
                        <strong>Formatos permitidos: .jpeg, .png, .jpg, .gif, .pdf, con un peso máximo de 500kb</strong>
                    </p>
                </div>
                <div class="col-12 col-sm-12">
                    <editor
                        v-model="note_refund"
                        plugins="lists advlist"
                        toolbar="bold italic | alignleft aligncenter alignright | bullist numlist | link image media | insertdatetime | code codesample"/>

                </div>

            </form>
            <div class="col-12 col-sm-12">
                <button id="dyn-button" class="btn btn-primary addNote" v-on:click="guardarTicket()">
                    Subir Ticket
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import {myMixins} from "../mixins/myMixins";
import Editor from '@tinymce/tinymce-vue'
import {ticketInvoiceService} from "../../Services/TicketInvoice.service";
import {getFormData} from "../../Utils/getDataForm";

export default {
    name: 'invoice-ticket',
    components: {
        'editor': Editor
    },
    mixins: [myMixins],
    props: {
        invoice_array: {
            type: Array,
            required: true
        },
        supplier_id: {
            type: Number,
            required: true,
            comments: 'Este es el nombre de la carpeta donde se va a subir el archivo dentro de afiliados',
        },
        type_model: {
            type: String,
            required: true,
            comments: 'Este me va a servir para saber a que carpeta va a subir el archivo',
        },
    },
    data() {
        return {
            modificar: false,
            tituloBtn: 'Agregar Documento',
            note_refund: '',
        }
    },
    methods: {
        async guardarTicket() {
            //console.log('guardarTicket');
            let resp = '';
            let respVal = this.valFormulariosV3('ticket_form');
            if (respVal) {
                this.disableSubmitBtn(true);
                //DINAMICAMENTE ASIGNAMOS EL VALOR DEL CAMPO A GUARDAR
                //this.ticket[myField] = this.item;
                const formData = getFormData('ticket_form');
                resp = await ticketInvoiceService.saveOne(formData, {
                    isForm: true,
                    onUploadProgress: this.onUploadProgress
                });

                this.getAlert(resp.process, true);
                this.disableSubmitBtn(false);
            }
            this.modificar = false;
        },

        getLogo(event) {
            this.getNameFile(event, 'ticket');
        },
    },
    mounted() {
    }
}
</script>
